module.exports = __webpack_public_path__ + "img/wallet-logo.2cb8bce8.png";